/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));




jQuery(function($) {
  if(document.location.hash!='#test-chevron') return;
  console.log('test chevron');
  $('.chevron_wrapper').each(function(k,v) {
    var el = $(v);
    v.style.position = 'relative';
    var title = el.find('.chevron_title');
    var w = title.width();
    //console.log(title,title.html(),w);
    var tmpCanvas = document.createElement('canvas');
    el.removeClass('chevron_wrapper');
    title.removeClass('chevron_title');
    tmpCanvas.style.width = '100%';
    tmpCanvas.style.height = '100%';
    tmpCanvas.style.top = 0;
    tmpCanvas.style.left = 0;
    tmpCanvas.style.position = 'absolute';
    tmpCanvas.style.zIndex = -1;
    el.append(tmpCanvas);
    //tmpCanvas.width = 100;
    //tmpCanvas.height = 100;
    setTimeout(function() { drawChevron(tmpCanvas,w); },100);
  });
  function drawChevron(canvas,textWidth) {
    var ctx = canvas.getContext('2d');
    var w = $(canvas.parentNode).width();
    var h = $(canvas.parentNode).height();
    canvas.width = w;
    canvas.height = h;
    var offset = 100;
    ctx.strokeStyle="red";
    
    console.log({w:w,h:h,tw:textWidth});
    ctx.beginPath();
    ctx.moveTo(0,h/2);
    ctx.lineTo(((w-textWidth)/2)-offset,h/2);
    //ctx.stroke();
    //ctx.beginPath();
    ctx.moveTo(w,h/2);
    ctx.lineTo(((w+textWidth)/2)+offset,h/2);
    //console.log(0,h,h/2,'to',50,h/2);
    ctx.stroke();
  }
});


function addCircleOnLoad(image,ep) {
  var baseImg = new Image();
  //console.log('checking',image,image.complete,image.src);
  if(!image.complete || (image.complete && image.src=='data:')) {
    jQuery(image).load(function() { addCircleOnLoad(image,ep); });
    return;
  }
  //console.log('drawing',image.complete,image.src);
  addCircle(image,ep);
}

function addCircle(image,ep) {
  //console.log('canvas',image,image.complete);
  var tmpCanvas = document.createElement('canvas'),
      tmpCtx = tmpCanvas.getContext('2d');
  var ip = $(image);
  tmpCanvas.className = 'circle-canvas';
  //console.log(ip.height());
  //tmpCanvas.width = 300;
  /*ip.width()*2;*/
  /*tmpCanvas.width = 100%;*/
  tmpCanvas.height = 300;
  var middleH = tmpCanvas.height/2;
  var middleW = tmpCanvas.width/2;
  var middle = middleH>middleW?middleW:middleH;
  /*ip.height()*2;*/
  console.log(image,ip);
  // draw the cached images to temporary canvas and return the context
  tmpCtx.save();
  tmpCtx.beginPath();
  tmpCtx.arc(middle, middle, middle, 0, Math.PI*2, true);
  tmpCtx.closePath();
  tmpCtx.clip();
  tmpCtx.drawImage(image, 0, 0, (middle+1)*2, (middle+1)*2);
  /*tmpCtx.beginPath();
  tmpCtx.arc(0, 0, 2, 0, Math.PI*2, true);
  tmpCtx.clip();
  tmpCtx.closePath();*/
  tmpCtx.restore();
  console.log('append to',ep);
  ep.replaceChild(tmpCanvas,image);
  //ep.appendChild(tmpCanvas);
//  jQuery(image).remove();
  //    $('body').append(tmpCanvas);
}

/*
jQuery(function($) {
  $('.circle-image').each(function(k,el) {
    el.style.display = 'none';
    var ep = el.parentNode;
    addCircleOnLoad(el,ep);
  });
});*/

jQuery(function($) {
  $('.filter-has-dropdown .primary-link').click(function(ev) {
    ev.preventDefault();
    $(ev.target.parentNode).find('.filter-dropdown-wrapper').toggleClass('mobile-active');
  });
});


jQuery(function($) {
  $(window).on('scroll',function() {
    if(window.pageYOffset>66) {
      $(document.body).addClass('has-scrolled');
    } else {
      $(document.body).removeClass('has-scrolled');
    }
  });
});

/*
jQuery(function($) {
  $(window).click(function(e) {
    var t = $(e.target);
    if(!t.hasClass('sidr-class-nav-primary-link') && !t.hasClass('sidr-class-nav-has-dropdown')) {
      return;
    }
    var el = t.hasClass('sidr-class-nav-has-dropdown')?t:t.parent('.sidr-class-nav-has-dropdown');
    if(!el[0]) return;
    e.preventDefault();
    el.find('.sidr-class-nav-dropdown').toggle();
    el.toggleClass('open');
  });
});*/

jQuery(function($) {
  var sidr = false;
  function cleanName(v) {
    if(v.className) {
      v.className = 'sidr-class-'+v.className.replace(/ +(?=[a-z0-9A-Z_-])/g,' sidr-class-');
    }
  }
  $('.top-menu .nav-bottom-row').each(function(k,v) {
    var p = v.cloneNode(true);
    //$('body').append(p);
    sidr = $(p);
    cleanName(p);
    sidr.find('*').each(function(k,v) {
      cleanName(v);
    });
  });
  var pt = $('.top-menu')[0].cloneNode(true);
  cleanName(pt);
  var pt = $(pt);
  pt.find('.nav-bottom-row-outer').remove();
  $(pt).find('.sidr-closed').removeClass('sidr-closed').addClass('sidr-open');
  $(pt).addClass('top-menu');
  var el = document.createElement('div');
  el.className = 'sidr top';
  el.appendChild(pt[0]);
  var c = document.createElement('div');
  c.className = 'sidr-inner';
  el.appendChild(c);
  c.appendChild(sidr[0]);
  $('body').append(el);
  
  $('body').on('click','.menu-opener-2',function(ev) {
    ev.preventDefault();
    console.log('a');
    $('.sidr.top').toggleClass('open');
    $('body').toggleClass('open_modal');
  });
});


jQuery(function($) {
  function clickCardDesktop(el,w,e,event) {
    if(el.hasClass('hover')) {
      
      if(event.target && (
        (event.target.tagName=='A')||(event.target.parentNode.tagName=='A'))) return;
      var orig = $('#'+el.data('oid'));
      var nPos = orig.offset();
      var l = nPos.left;
      //+ parseInt(orig.css('marginLeft'), 10) + parseInt(orig.css('paddingLeft'),10);
      var l = l-w.scrollLeft();
      var t = nPos.top- w.scrollTop();
      //console.log(orig.width(),orig.height(),orig.innerWidth(),orig.outerWidth());
      el.css({position:'fixed',left:l+'px',top:t+'px',zIndex: 9000,width:orig.outerWidth()+'px',height:orig.outerHeight()+'px'}).removeClass('hover').addClass('transit');
      if(mask) {
        mask.style.opacity = 0;
        mask.parentNode.removeChild(mask);
      }
      setTimeout(function() { el.remove(); orig.css({opacity:''}); },600); // should match animation time!
    } else {
      if(el.css('opacity')=='0') return;
      var pos = el.offset();
      var l = pos.left-w.scrollLeft();
      var t = pos.top- w.scrollTop();
      var newN = el.clone(true);
      newN.css({position:'fixed',left:l+'px',top:t+'px',zIndex: 9000});
      newN.data('oid',el.attr('id'));
      newN.attr('id','');
      $('body').append(newN);
      el.addClass('transit');
      $('body').append(mask);
      setTimeout(function() { newN.addClass('hover middle-pos').css({left:'',top:''}); mask.style.opacity = finalOpacity; },50);
      el.css({opacity:'0'});
      setTimeout(
        function() { 
          el.removeClass('transit'); 
        }
        ,600); // should match animation time!
      return;
    }
  }
  function clickCardMobile(el,w,e,event) {
    if(el.hasClass('modal')) {
      if(event.target.className != 'mobile-postcard-close') return;
/*      if(event.target && (
        (event.target.tagName=='A')||(event.target.parentNode.tagName=='A'))) return;
      var orig = $('#'+el.data('oid'));*/
      el.remove();
      $('body').removeClass('open_modal');
      return;
    } else {
      var newN = el.clone(true);
      newN.data('oid',el.attr('id'));
      newN.attr('id','');
      newN.addClass('modal');
      newN.css('height',$(window).height()+'px');
      $('body').append(newN).addClass('open_modal');
      return;
    }
  }
  var mask = false;
          mask = document.createElement('div');
          mask.style.position = 'fixed';
          mask.style.top = mask.style.left = '0';
          mask.style.width = mask.style.height = '100%';
          mask.style.zIndex = 999;
          mask.style.background = '#555';
          mask.style.opacity = '0';
  mask.style.transition = '1s';
  mask.className = 'mask';
  var finalOpacity = 0.3;
  $('body').on('click','.mask',function() {
    $('.flip-container.hover').trigger('click');
  });
  
  $(window).on('resize', function() {
    if($( window ).width()<768) {
      $('.flip-container.hover').remove();
      $('.flip-container').css('opacity','');
      if(mask.parentNode) {
        mask.parentNode.removeChild(mask);
      }
      $('.modal').css('height',$(window).height()+'px');
    } else {
      $('body').removeClass('open_modal');
      $('.modal').remove();
    }

  });
  $('.flip-container').click(function(event) {
    var e = this;
    var w = jQuery(window);
    var el = jQuery(e);
    if(el.hasClass('transit')) return;
    if($( window ).width()>=768) {
      clickCardDesktop(el,w,e,event);
    } else {
      clickCardMobile(el,w,e,event);
    }
  });
});

